


















import { Component, Prop, Vue } from 'vue-property-decorator';

import Arrow from '@/components/icons/Arrow.vue';

type Config = {
  maxWidthTitle?: string;
  maxWidthDescription?: string;
};

type CtaCardVariant = 'normal' | 'customer-import';

const defaultConfig = {
  maxWidthTitle: '100%',
  maxWidthDescription: '100%'
};

@Component({
  components: {
    Arrow
  }
})
export default class CtaCard extends Vue {
  @Prop(String) title!: string;
  @Prop(String) description!: string;
  @Prop({ default: () => defaultConfig }) config?: Config;
  @Prop({ default: 'normal' }) variant?: CtaCardVariant;

  get configOptions() {
    return Object.assign({}, defaultConfig, this.config);
  }

  get titleStyle() {
    return {
      '--cta-card-max-width-title': this.configOptions.maxWidthTitle
    };
  }

  get descriptionStyle() {
    return {
      '--cta-card-max-width-description': this.configOptions.maxWidthDescription
    };
  }
}
